/*********************
Grapheme Rule
*********************/
import Rule from '../Rule';
import { ruleInputTypes, ruleTypes } from '../../../constants';
import {buildLogForRule} from '../../../utils/logUtils';

export default class GraphemeRule extends Rule {
  constructor(logic) {
    super([ruleInputTypes.word_GRAPHEMIC_BREAKDOWN],logic);
    this.ruleType = ruleTypes.GRAPHEME;
  }

  // override the default run rule
  run(state) {
    let meetsGraphemeRule = false;
    let numGraphemes = 'undefined';
    if(state.word_GRAPHEMIC_BREAKDOWN && state.word_GRAPHEMIC_BREAKDOWN.split("/").length) {
      numGraphemes = state.word_GRAPHEMIC_BREAKDOWN.split("/").length;
      meetsGraphemeRule = this.logic(numGraphemes);
    }
    return {
      stateMeetsRuleCondition: meetsGraphemeRule,
      decisionContext: {[(this.ruleType + '_'+meetsGraphemeRule)]: 'error met specified grapheme condition = ' + numGraphemes},
      log: buildLogForRule(this, state, meetsGraphemeRule),
    }
  }
}